// extracted by mini-css-extract-plugin
module.exports = {"loggedOutPage":"loggedOutPage_loggedOutPage__1EEVC","centerFormInfo":"loggedOutPage_centerFormInfo__1NAet"};